<!--
 * @Author: your name
 * @Date: 2022-01-13 23:50:14
 * @LastEditTime: 2022-07-21 15:04:31
 * @LastEditors: ettttt etwl@didiglobal.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /soda-act/src/page/c/newCoupon/components/footer/index.vue
-->
<template>
    <div class="footer-container">
      <FooterTips 
      v-if="status===2" 
      :refreshTs="refreshTs"
      @get-task-init="getTaskInit"
      />
      <PayList v-if="status===1"/>
      <FooterBtn 
      :status="status" 
      :priceText="priceText"
      :productId="productId"
      :price="price"
      :bubbleContent="bubbleContent"
      @coupon-package-pay="couponPackagePay"
      />
    </div>
</template>
<script>
import PayList from './payList.vue'
import FooterBtn from './footerBtn.vue'
import FooterTips from './footerTips.vue'
export default {
  name: 'Footer',
  props: ['status', 'refreshTs', 'priceText', 'productId', 'price', 'bubbleContent'],
  components: {
    PayList,
    FooterBtn,
    FooterTips
  },
  methods: {
    getTaskInit () {
      this.$emit('get-task-init')
    },
    couponPackagePay () {
      this.$emit('coupon-package-pay')
    }
  }

}
</script>
<style lang="scss" scoped>

.footer-container{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: 750px;
  background: #FFFFFF;
  box-shadow: 0px 0px 48px 0px rgba(0,0,0,0.06);
  padding: 0 24px 68px;
  box-sizing: border-box;
}
</style>